import { BackendSocket } from '../../hooks/use-socket';
import { BackendPayload } from './payloads';
import { closeModal } from '../../stores/backend';
import { meta } from '../../stores/backend';
import { isSuspended } from '../../lib/suspension';

export const onConnect = (
    socket: BackendSocket,
    { payload }: { payload: BackendPayload }
) => {
    const callback = async () => {
        const connectionId = socket.id;
        // Default to false (manual reload required) unless explicitly set to 'true'
        const autoReconnect =
            import.meta.env.REACT_APP_WS_AUTO_RECONNECT === 'true';

        if (
            !(await payload.loadGame()) ||
            isSuspended() ||
            socket.id !== connectionId
        )
            return;
        if (
            !(await payload.loadGame(true)) ||
            isSuspended() ||
            socket.id !== connectionId
        )
            return;

        // If auto-reconnect is enabled, close the modal after successful reconnection
        if (autoReconnect) {
            if (meta.modals.msgCommon.isOpen.value) {
                closeModal('msgCommon');
            }
        }
        // Otherwise, user must manually reload via the button shown in the modal
    };

    socket.on('connect', callback);

    return () => {
        socket.off('connect', callback);
    };
};
